import identityManagementImg from 'assets/icons/home-page/identity-management.webp'
import accessManagementImg from 'assets/icons/home-page/access-management.svg'
import deviceManagementImg from 'assets/icons/home-page/device-management.webp'
import automateImg from 'assets/icons/common/automate.svg'
import heroImg from 'assets/icons/home-page/hero.webp'
import oldItImg from 'assets/icons/home-page/oldit.svg'
import newItImg from 'assets/icons/common/zenadmin-double-border.svg'
import tickImg from 'assets/icons/common/tick.svg'
import crossImg from 'assets/icons/common/cross.svg'
import appsImg from 'assets/icons/common/app.svg'
import fileCheckImg from 'assets/icons/common/file-check.svg'
import lineThroughFileImg from 'assets/icons/common/line-through-file.svg'
import iphoneSendImg from 'assets/icons/common/iphone-old-send.svg'
import mouseKeyboardImg from 'assets/icons/common/mouse-keyboard.svg'
import shieldLock2Img from 'assets/icons/common/shield-lock-2.svg'
import dbImg from 'assets/icons/common/db.svg'
import securityImg from 'assets/icons/common/security.svg'
import automateItTaskImg from 'assets/icons/home-page/automate-it-task.webp'
import companyAssetsImg from 'assets/icons/home-page/company-assets.webp'
import cyberSecurityImg from 'assets/icons/home-page/cyber-security.svg'

import apteliyzImg from 'assets/icons/client-icons/apteliyz.svg'
import beamImg from 'assets/icons/client-icons/beam.svg'
import brighteraiImg from 'assets/icons/client-icons/brighterai.svg'
import bringoImg from 'assets/icons/client-icons/bringo.svg'
import carousellImg from 'assets/icons/client-icons/carousell.svg'
import coveImg from 'assets/icons/client-icons/cove.svg'
import cybusImg from 'assets/icons/client-icons/cybus.svg'
import cycleImg from 'assets/icons/client-icons/cycle.svg'
// import emmyy1Img from 'assets/icons/client-icons/emmy1.svg'
import foodjiImg from 'assets/icons/client-icons/foodji.svg'
import mindbodyImg from 'assets/icons/client-icons/mindbody.svg'
import multiplierImg from 'assets/icons/client-icons/multiplier.svg'
import numaImg from 'assets/icons/client-icons/numa.svg'
import omnipresentImg from 'assets/icons/client-icons/omnipresent.svg'
import provenirImg from 'assets/icons/client-icons/provenir.svg'
import quinsusImg from 'assets/icons/client-icons/quinsus.svg'
import getsafeImg from 'assets/icons/client-icons/getsafe.svg'
import spearedImg from 'assets/icons/client-icons/speared.svg'
import starbrustImg from 'assets/icons/client-icons/starbrust.svg'
import temusImg from 'assets/icons/client-icons/temus.svg'
import vitalImg from 'assets/icons/client-icons/vital.svg'
import workatoImg from 'assets/icons/client-icons/workato.svg'

import androidImg from 'assets/icons/home-page/android.webp'
import appleImg from 'assets/icons/home-page/apple.webp'
import asanaImg from 'assets/icons/home-page/asana.webp'
import bingeImg from 'assets/icons/home-page/binge.webp'
import mazeImg from 'assets/icons/home-page/maze.webp'
import mircosoftImg from 'assets/icons/home-page/mircosoft.webp'
import pintrestImg from 'assets/icons/home-page/pintrest.webp'
import salesforceImg from 'assets/icons/home-page/salesforce.svg'
import slackImg from 'assets/icons/home-page/slack.webp'
import windowImg from 'assets/icons/home-page/window.webp'
import googleWorkspaceImg from 'assets/icons/home-page/google-workspace.webp'

import {HeroSectionDataType, HybridWorksData, ItManagementData} from './contentTypes'
import {DEMO_LINK} from 'utils/getters'

export const heroSectionData: HeroSectionDataType = {
  topTitle: 'ZENADMIN Platform',
  title: 'Manage your IT in one place ',
  titleVariant: {
    text: 'without the headache',
    color: '#5171E1',
  },
  desc: 'Manage your IT along the employee lifecycle without the pain of IT administration & security processes.',
  cta: {
    text: 'Schedule a demo',
    link: DEMO_LINK,
  },
  imgSrc: heroImg.src,
}
export const itManagementData: ItManagementData = {
  topTitle: 'Why ZENADMIN',
  bgColor: '#EBF5FE',
  title: 'Handling employee-centric IT management ',
  titleVariant: {
    text: 'is mission critical for SMBs',
    color: '#5171E1',
  },
  oldWays: {
    imgSrc: oldItImg,
    title: 'IT Management the old way',
    listIcon: crossImg,
    list: [
      'Asset inventory in outdated spreadsheets',
      `IT Management as a side job or no one's job`,
      'Lots of time consumed by manual and repetitive tasks',
      'Lack of dedicated security knowledge',
      'Major source of frustration among employees',
    ],
  },
  newWays: {
    imgSrc: newItImg,
    title: 'IT Management with ZenAdmin',
    listIcon: tickImg,
    list: [
      'Holistic IT management along the employee lifecycle',
      `Security & compliance by design`,
      'High automation degree through pre-configured workflows',
      'Costs savings & best practices through standardization',
      'Transparency & insights through connected data',
    ],
  },
}
export const identityManagementData = {
  topTitle: 'Identity Management',
  title: 'Ensure secure,<br/> compliant & efficient access to cloud-based resources and data',
  desc: 'Maintain control over who has access to your cloud-based resources and data. Onboard & offboard new employees with ease. Automate IT onboarding & offboarding, access approvals and zero-touch device enrollment.',
  infoBoxes: [
    {
      title: 'Implementation of security best practices',
      icon: securityImg,
    },
    {
      title: 'Automated onboarding & offboarding',
      icon: automateImg,
    },
    {
      title: 'Controlled data access',
      icon: dbImg,
    },
  ],
  imageSrc: identityManagementImg,
  id: 'employee-directory',
  primaryCta: {
    text: 'Get started',
    url: DEMO_LINK,
  },
}

export const accessManagementData = {
  topTitle: 'Access Management',
  title: 'Centralized control over access to third-party SaaS applications',
  desc: 'Ensure that only authorized users can access company resources and data while reducing administrative overhead and improving productivity for IT Admins & HR.',
  infoBoxes: [
    {
      title: 'Transparent app inventory',
      icon: appsImg,
    },
    {
      title: 'Documented access management & approvals',
      icon: fileCheckImg,
    },
    {
      title: 'Reduction of ghost licences',
      icon: lineThroughFileImg,
    },
  ],
  imageSrc: accessManagementImg,
  id: 'employee-directory',
  primaryCta: {
    text: 'Get started',
    url: DEMO_LINK,
  },
}

export const deviceManagementData = {
  topTitle: 'Device Management',
  title: 'Manage any device, anywhere, anytime',
  desc: 'Securely manage company devices from one place. Streamline setup, reduce admin tasks, and stay compliant. Manage any device from anywhere via our platform.',
  infoBoxes: [
    {
      title: 'Integrated Mobile Device Management (MDM)',
      icon: iphoneSendImg,
    },
    {
      title: 'Transparent device inventory',
      icon: mouseKeyboardImg,
    },
    {
      title: 'Secure devices through central policies',
      icon: shieldLock2Img,
    },
  ],
  imageSrc: deviceManagementImg,
  id: 'employee-directory',
  primaryCta: {
    text: 'Get started',
    url: DEMO_LINK,
  },
}

export const hybridWorksData: HybridWorksData = {
  topTitle: 'Reduce IT Workload & increase COmpliance in 3 steps',
  title: 'How ZenAdmin works',
  desc: 'Your one-stop shop for your IT Administration & Security workflows along the employee lifecycle.',
  slides: [
    {
      btnDetails: {
        text: 'Integrate core systems',
        desc: 'Gain transparency and insights over all company assets.',
      },
      slideDetails: {
        imgSrc: companyAssetsImg,
        imgBg: 'rgba(37, 77, 218, 0.25)',
        background: '',
        topTitle: 'Integrate core systems',
        title: 'Gain transparency and insights over all company assets',
        tags: [
          'HR System',
          'Google Workspace',
          'Microsoft 365',
          'SaaS Applications',
          'Mobile Devices',
        ],
      },
    },
    {
      btnDetails: {
        text: 'Automate IT workflows',
        desc: 'Reduce workload for manual IT tasks and reduce costs.',
      },
      slideDetails: {
        imgSrc: automateItTaskImg,
        imgBg: 'rgba(37, 77, 218, 0.25)',
        background: '',
        topTitle: 'AUTOMATE IT WORKFLOWS',
        title: 'Automate routine IT tasks and reduce costs',
        tags: [
          'IT Onboarding & Offboarding',
          'Identity Creation (incl. groups, mailing lists etc.)',
          'SaaS App Account Creation',
          'Zero Touch Device Enrollment',
          'Access Management & Approval Flows',
        ],
      },
    },
    {
      btnDetails: {
        text: 'Boost IT security setup',
        desc: 'Get out-of-the-box security best practices implemented.',
      },
      slideDetails: {
        imgSrc: cyberSecurityImg,
        imgBg: 'rgba(37, 77, 218, 0.25)',
        background: '',
        topTitle: 'BOOST IT SECURITY SETUP',
        title: 'Get cybersecurity best practices implemented company-wide',
        tags: [
          'Roles & Rights Management',
          'Managed & Secured Devices',
          'Access Reviews',
          'ISO 27001 Controls Covered',
          'GDPR Requirements Covered',
        ],
      },
    },
  ],
}

export const companyLogos = [
  {
    img: multiplierImg,
    alt: 'multiplier',
    width: 99,
    height: 31,
  },
  {
    img: quinsusImg,
    alt: 'quinsus',
    width: 99,
    height: 32,
  },
  {
    img: carousellImg,
    alt: 'carsousell',
    width: 142,
    height: 31,
  },
  {
    img: cybusImg,
    alt: 'cybus',
    width: 106,
    height: 29,
  },
  // {
  //   img: spearedImg,
  //   alt: 'sapered',
  //   width: 129,
  //   height: 16,
  // },
  {
    img: getsafeImg,
    alt: 'getsafe',
    width: 170,
    height: 30,
  },
  {
    img: vitalImg,
    alt: 'vytal',
    width: 63,
    height: 29,
  },
  {
    img: brighteraiImg,
    alt: 'brighterAI',
    width: 124,
    height: 22,
  },
  {
    img: cycleImg,
    alt: 'cycle',
    width: 75,
    height: 20,
  },
  {
    img: apteliyzImg,
    alt: 'apteliyz',
    width: 79,
    height: 26,
  },
  {
    img: foodjiImg,
    alt: 'foodjii',
    width: 73,
    height: 25,
  },
  {
    img: coveImg,
    alt: 'cove',
    width: 54,
    height: 18,
  },
  {
    img: beamImg,
    alt: 'beam',
    width: 74,
    height: 27,
  },
  {
    img: starbrustImg,
    alt: 'starbrust',
    width: 145,
    height: 37,
  },
  {
    img: numaImg,
    alt: 'numa',
    width: 84,
    height: 30,
  },
  {
    img: workatoImg,
    alt: 'workato',
    width: 153,
    height: 31,
  },
  {
    img: mindbodyImg,
    alt: 'mindbody',
    width: 115,
    height: 35,
  },
  {
    img: provenirImg,
    alt: 'provenir',
    width: 158,
    height: 24,
  },
  {
    img: omnipresentImg,
    alt: 'omnipresent',
    width: 130,
    height: 24,
  },
  {
    img: temusImg,
    alt: 'temus',
    width: 75,
    height: 22,
  },
  // {
  //   img: bringoImg,
  //   alt: 'bringoo',
  //   width: 110,
  //   height: 41,
  // },
  // {
  //   img: emmyy1Img,
  //   alt: 'emmy',
  //  width: 41,
  // height: 41,
  // },
]

export const heroLastData = [
  {
    imgs: [
      {
        src: googleWorkspaceImg,
        imgHeight: 24,
        imgWidth: 193,
        ratioHeight: undefined,
        ratioWidth: undefined,
      },
      {
        src: mircosoftImg,
        imgHeight: 28,
        imgWidth: 155,
        ratioHeight: undefined,
        ratioWidth: undefined,
      },
    ],

    title: 'Identity & Access Management',
  },
  {
    imgs: [
      {
        src: pintrestImg,
        imgHeight: 48,
        imgWidth: 48,
        ratioHeight: undefined,
        ratioWidth: undefined,
      },
      {src: bingeImg, imgHeight: 48, imgWidth: 48, ratioHeight: undefined, ratioWidth: undefined},
      {src: mazeImg, imgHeight: 48, imgWidth: 48, ratioHeight: 218, ratioWidth: 206},
    ],
    title: 'Employee Lifecycle Management',
  },
  {
    imgHeight: 193,
    imgWidth: 24,
    imgs: [
      {src: slackImg, imgHeight: 48, imgWidth: 48, ratioHeight: undefined, ratioWidth: undefined},
      {src: asanaImg, imgHeight: 48, imgWidth: 48, ratioHeight: undefined, ratioWidth: undefined},
      {
        src: salesforceImg,
        imgHeight: 45,
        imgWidth: 62,
        ratioHeight: undefined,
        ratioWidth: undefined,
      },
    ],
    title: 'App Management',
  },
  {
    imgHeight: 193,
    imgWidth: 24,
    imgs: [
      {src: windowImg, imgHeight: 56, imgWidth: 55, ratioHeight: undefined, ratioWidth: undefined},
      {src: appleImg, imgHeight: 56, imgWidth: 56, ratioHeight: undefined, ratioWidth: undefined},
      {src: androidImg, imgHeight: 62, imgWidth: 62, ratioHeight: undefined, ratioWidth: undefined},
    ],
    title: 'Device Management',
  },
]
